import * as productsTypes from '../types/Products';
import {handleError} from './ErrorHandler';
import * as errorActions from '../actions/Error';
import { COMPLAINT_POSITION_ERROR } from '../const/ErrorPlace';
import * as apiCalls from '../api/ApiCalls';
import {ChangeProduct} from './ComplaintPosition';
import { hideModal } from './Modal';

export function searchProductsByText(text) {
    return async (dispatch, getState) => {
        dispatch(searchProductsByTextRequest());
        try {
            const complaintTypeId = getState().complaint.complaintType.id;
            const response = await apiCalls.GetProductsByText(text, complaintTypeId);
            const result =  await response.json();
            if(response.status===200) {
                dispatch(errorActions.clearError());
                dispatch(searchProductsByTextSuccess(result));
            }
            else{
                return dispatch(errorActions.throwErrorByPlace(COMPLAINT_POSITION_ERROR, {
                    errorTitle: "Błąd pobierania danych",
                    errorMessage: result.exceptionMessage
                }));
            }
        } catch (error) {
            handleError(dispatch, error, productsTypes.PRODUCT_SEARCH_PRODUCTS_BY_TEXT_FAILURE);
        }
    };
} 

export function searchProductsByTextFailure() {
    return {
        type: productsTypes.PRODUCT_SEARCH_PRODUCTS_BY_TEXT_FAILURE
    };
}

export function searchProductsByTextRequest() {
    return {
        type: productsTypes.PRODUCT_SEARCH_PRODUCTS_BY_TEXT_REQUEST
    };
}

export function searchProductsByTextSuccess(products) {
    return {
        type: productsTypes.PRODUCT_SEARCH_PRODUCTS_BY_TEXT_SUCCESS,
        payload: products
    };
}

export function ChangeSelectedRow(selectedRow) {
    return {
        type: productsTypes.PRODUCT_CHANGE_SELECTED_ROW,
        payload: selectedRow
    };
}

export function ChangeTablePage(tablePage) {
    return {
        type: productsTypes.PRODUCT_CHANGE_TABLE_PAGE,
        payload: tablePage
    };
}

export function ChangeTextForSearching(text){
    return{
        type: productsTypes.PRODUCT_CHANGE_TEXT_FOR_SEARCHING,
        payload: text
    };
}

export function IsProductSelected(selectedProduct){
    return selectedProduct!==null;
}



export function ConfirmModal(selectedRow){
    return async (dispatch) => {
        dispatch(ConfirmModalRequest(selectedRow));
        dispatch(ChangeProduct(selectedRow));
        dispatch(hideModal());
    };
}

export function ConfirmModalRequest(selectedRow) {
    return{
        type: productsTypes.PRODUCT_CONFIRM_MODAL,
        payload: selectedRow
    };
}


// WEBPACK FOOTER //
// ./src/actions/Products.js